function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { InfoOutlined } from "@mui/icons-material";
import { IconButton, Tooltip as MuiTooltip } from "@mui/material";
import cn from "clsx";
export var IconTooltip = function(_param) {
    var ariaLabel = _param['aria-label'], _param_arrow = _param.arrow, arrow = _param_arrow === void 0 ? true : _param_arrow, className = _param.className, children = _param.children, onClick = _param.onClick, placement = _param.placement, title = _param.title, _param_trigger = _param.trigger, trigger = _param_trigger === void 0 ? /*#__PURE__*/ _jsx(InfoOutlined, {
        color: "primary",
        fontSize: "small"
    }) : _param_trigger, props = _object_without_properties(_param, [
        'aria-label',
        "arrow",
        "className",
        "children",
        "onClick",
        "placement",
        "title",
        "trigger"
    ]);
    return /*#__PURE__*/ _jsx(MuiTooltip, {
        "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : 'More Info',
        arrow: arrow,
        componentsProps: {
            popper: {
                // @ts-expect-error - problems with types
                'data-testid': props['data-testid']
            }
        },
        describeChild: true,
        enterTouchDelay: 0,
        onClick: onClick,
        placement: placement,
        title: title || children,
        children: /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread({}, props), {
            className: cn('ml-1', className),
            size: "small",
            children: trigger
        }))
    });
};

//# sourceMappingURL=IconTooltip.js.map